import { Injectable } from '@angular/core';
import { OrganizationType } from '@core/models/organization.model';
import { User } from '@core/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  public isInvestorCompany(type: OrganizationType): boolean {
    return type === 'investor';
  }

  public isEmittentCompany(type: OrganizationType): boolean {
    return type === 'emittent';
  }

  public isDdUser(user: User | null | undefined): boolean {
    if (!user) {
      return false;
    }
    // Use the User model's isDDUser() method which checks for DD Admin or DD Analyst roles
    return user.isDDUser?.() ?? false;
  }

  public isDdAnalyst(user: User | null | undefined): boolean {
    if (!user) {
      return false;
    }
    // Use the User model's hasDDRole() method to check specifically for DD Analyst role
    return user.hasDDRole?.('analyst') ?? false;
  }

  /** Staff, superuser flag, or partner admin — same criteria as post-login superuser flow. */
  public canAccessSuperUserArea(user: User | null | undefined, userTypeHint?: string | null): boolean {
    if (!user) {
      return false;
    }

    if (user.isStaff === true) {
      return true;
    }

    if (user.isSuperUser === true) {
      return true;
    }

    const userType = (
      userTypeHint ??
      user.userType ??
      (user as { user_type?: string }).user_type ??
      ''
    ).toLowerCase();
    if (userType === 'superuser' || userType === 'partner_admin') {
      return true;
    }

    const isPartnerAdmin =
      typeof user.isPartnerAdmin === 'function' ? user.isPartnerAdmin() : !!user.partnerAdmin?.uid;

    return isPartnerAdmin || (user.partnerAdminPartners?.length ?? 0) > 0;
  }
}
